export default __webpack_public_path__ + "static/media/icon5.3e3bf4df.svg";